import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const DashboardSchema = withDefaults({
  type: 'dashboard',
  objectExtensions: ['dashboard'],
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'layoutConfig',
    },
    {
      kind: 'attribute',
      name: 'visibilityLevel',
    },
    {
      kind: 'attribute',
      name: 'partnerAccessConfig',
    },
    {
      kind: 'attribute',
      name: 'isDefault',
    },
    {
      kind: 'attribute',
      name: 'isTemplate',
    },
    {
      kind: 'attribute',
      name: 'templateKey',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'updatedBy',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'hasMany',
      name: 'dashboardReports',
      type: 'dashboard-report',
      options: {
        async: false,
        inverse: 'dashboard',
      },
    },
  ],
});

export default DashboardSchema;
